import React, { useEffect, useRef } from "react";
import svg9 from "../../assets/svg/svg9.svg";
import svg10 from "../../assets/svg/svg10.svg";
import landingBusiness from "../../assets/img/landing-business-side.png";
import mpesa from "../../assets/img/mpesa.png";
import dtb from "../../assets/img/dtb.png";
import pesalink from "../../assets/svg/pesalink.svg";
import nabo from "../../assets/svg/nabo.svg";
import { useNavigate } from "react-router-dom";

function Hero() {
  const firstPairRef = useRef(null);
  const secondPairRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    let currentPair = 0; // 0 for first, 1 for second
    let animationProgress = 0;
    const displayTime = 3000; // Show each pair for 3 seconds
    const transitionDuration = 1500; // Transition duration

    const interval = setInterval(() => {
      animationProgress += 20;

      if (animationProgress <= displayTime) {
        // Display phase - show current pair fully
        if (
          currentPair === 0 &&
          firstPairRef.current &&
          secondPairRef.current
        ) {
          firstPairRef.current.style.transform = "translateX(0)";
          firstPairRef.current.style.opacity = "1";
          firstPairRef.current.style.transition = "none";
          secondPairRef.current.style.transform = "translateX(100%)";
          secondPairRef.current.style.opacity = "0";
          secondPairRef.current.style.transition = "none";
        } else if (
          currentPair === 1 &&
          firstPairRef.current &&
          secondPairRef.current
        ) {
          secondPairRef.current.style.transform = "translateX(0)";
          secondPairRef.current.style.opacity = "1";
          secondPairRef.current.style.transition = "none";
          firstPairRef.current.style.transform = "translateX(-100%)";
          firstPairRef.current.style.opacity = "0";
          firstPairRef.current.style.transition = "none";
        }
      } else if (animationProgress <= displayTime + transitionDuration) {
        // Transition phase - current pair exits while next pair enters
        const progress = (animationProgress - displayTime) / transitionDuration;

        if (
          currentPair === 0 &&
          firstPairRef.current &&
          secondPairRef.current
        ) {
          // First pair scrolls left (out)
          firstPairRef.current.style.transition = "none";
          firstPairRef.current.style.transform = `translateX(-${
            progress * 100
          }%)`;
          firstPairRef.current.style.opacity = `${1 - progress}`;

          // Second pair scrolls from right (in)
          secondPairRef.current.style.transition = "none";
          secondPairRef.current.style.transform = `translateX(${
            100 - progress * 100
          }%)`;
          secondPairRef.current.style.opacity = `${progress}`;
        } else if (
          currentPair === 1 &&
          firstPairRef.current &&
          secondPairRef.current
        ) {
          // Second pair scrolls right (out)
          secondPairRef.current.style.transition = "none";
          secondPairRef.current.style.transform = `translateX(${
            progress * 100
          }%)`;
          secondPairRef.current.style.opacity = `${1 - progress}`;

          // First pair scrolls from left (in)
          firstPairRef.current.style.transition = "none";
          firstPairRef.current.style.transform = `translateX(-${
            100 - progress * 100
          }%)`;
          firstPairRef.current.style.opacity = `${progress}`;
        }
      } else {
        currentPair = currentPair === 0 ? 1 : 0;
        animationProgress = 0;
      }
    }, 20);

    return () => clearInterval(interval);
  }, []);

  const handleLogin = async () => {
    window.location.href="https://app.ndovupay.org/#/login" 
  };

  const handleRegister = async () => {
    window.location.href="https://app.ndovupay.org/#/registration"
  };
  return (
    <>
      <div className="lg:mt-[5.12rem] mt-[1rem] flex lg:flex-row flex-col justify-between font-lexendS gap-[2rem] lg:gap-[4rem]">
        <div className="flex-1 lg:max-w-[50%] w-full">
          <div
            className="rounded-[624.9375rem] border border-[#1E191B] inline-flex
        shadow-[0_0_0_1px_#E2E8F0,0_1px_2px_0_rgba(0,0,0,0.05)] py-[.375rem] px-[.75rem] gap-[.5rem] items-center max-w-full"
          >
            <img src={svg9} alt="svg9" className="flex-shrink-0" />
            <span className="text-[#334155] text-[.75rem] font-[500] leading-[1rem] truncate">
              New: Real‑time settlement and auto‑reconciliation
            </span>
          </div>

          <div className="text-[#1E191B] text-[1.75rem] md:text-[2.5rem] lg:text-[3rem] font-[500] leading-tight lg:leading-[3.375rem] mt-[1.25rem]">
            Powering Seamless <br className="hidden lg:block" /> Payments{" "}
            <br className="hidden lg:block" /> for Businesses
          </div>

          <div className="mt-[.62rem] text-[#4F4F4E] text-[1rem] font-[400] leading-[1.625rem] max-w-full lg:max-w-[26.875rem]">
            Whether you're a contractor, event organizer, or SME Ndovu Pay lets
            you send, receive, and manage money.
          </div>

          <div className="mt-[1.81rem] flex flex-wrap items-center gap-[.62rem]">
            <button
              className="flex min-w-[11rem] justify-center text-white items-center landing-btn px-[1rem] py-[.75rem] gap-[.5rem]"
              onClick={handleRegister}
            >
              Sign Up <img src={svg10} alt="svg10" />
            </button>
            <button
              className="flex items-center min-w-[11rem] rounded-[6.25rem] justify-center border border-[#000] px-[1rem] py-[.75rem] gap-[.5rem] shadow-[0_1px_3px_0_rgba(47,43,67,0.10),_0_-1px_0_0_rgba(47,43,67,0.10)_inset]"
              onClick={handleLogin}
            >
              Sign In
            </button>
          </div>

          <div className="mt-[2.94rem] text-[#000] lg:gap-[.5rem] flex lg:flex-row flex-col lg:items-center items-start text-[1.125rem] font-[400] lg:leading-[1.625rem]">
            <span className="mb-[0.5rem] lg:mb-0 whitespace-nowrap">
              In Partnership With
            </span>
            <div className="relative w-full lg:max-w-[20rem] h-[5.1875rem] overflow-hidden">
              <div
                ref={firstPairRef}
                className="absolute inset-0 flex items-center gap-4"
                style={{ opacity: 0 }}
              >
                <img
                  src={dtb}
                  alt="dtb"
                  className="h-[2rem] w-[9.1875rem] object-cover"
                />
                <img
                  src={mpesa}
                  alt="mpesa"
                  className="w-[7.125rem] h-[5.1875rem] object-cover"
                />
              </div>

              <div
                ref={secondPairRef}
                className="absolute inset-0 flex items-center gap-4"
                style={{ opacity: 0 }}
              >
                <img
                  src={pesalink}
                  alt="pesalink"
                  className="h-[2rem] w-[9.1875rem] object-cover"
                />
                <img
                  src={nabo}
                  alt="nabo"
                  className="w-[4.25rem] h-[4.25rem] object-cover"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="flex-1 lg:max-w-[50%] w-full flex items-center justify-center lg:mt-[3rem] mt-[2rem]">
          <img
            src={landingBusiness}
            alt="landingBusiness"
            className="object-contain w-full max-w-[45rem] h-auto"
          />
        </div>
      </div>
    </>
  );
}

export default Hero;
